import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-car-template-info',
  imports: [TranslatePipe],
  templateUrl: './car-template-info.component.html',
  styleUrls: [
    './car-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class CarTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'car.';
}
